import { useEffect } from "react";
import { useTranslate } from "@tolgee/react";
import ClientHomeSections from "../components/ClientHomeSections";

const HomePage = () => {
  const { t } = useTranslate();

  useEffect(() => {
    document.title = t('home.page_title');
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', t('home.meta_description'));
    const ld = (window as any).__LD_JSON__ || [];
    const holder = document.querySelector('script[type="application/ld+json"]');
    if (holder && ld) {
      holder.textContent = JSON.stringify(ld);
    }
  }, [t]);

  return (
    <div className="relative overflow-x-hidden">
      <ClientHomeSections />
    </div>
  );
};

export default HomePage; 